import { SECTION_MAP } from "../../task-list/lib/constants";
import {
    faClipboardList,
    faCamera,
    faCopy,
    faRulerCombined,
    faEye,
    faFileAlt,
    faImage,
    faImages,
    faClipboardCheck,
} from "@fortawesome/free-solid-svg-icons";
import { capitalizeFirstLetter } from "../../../shared/helpers";

export const taskDefinitions = {
    measuring: { label: "Measuring", icon: faRulerCombined },
    photography: { label: "Photography", icon: faCamera },
    scheduling: { label: "Profiling", icon: faClipboardList },
    coding: { label: "Coding", icon: faFileAlt },
    codingqa: { label: "Coding QA", icon: faCopy },
    imageediting: { label: "Image Editing", icon: faImage },
    imageeditingqa: { label: "Image Editing QA", icon: faImages },
    finalqa: { label: "Final QA", icon: faEye },
};

export const taskIcons = [
    { taskType: "photography", label: "Photography", icon: faCamera },
    { taskType: "scheduling", label: "Profiling", icon: faClipboardList },
    { taskType: "measuring", label: "Measuring", icon: faRulerCombined },
    { taskType: "coding", label: "Coding", icon: faFileAlt },
    { taskType: "codingqa", label: "Coding QA", icon: faCopy },
    { taskType: "imageediting", label: "Image Editing", icon: faImage },
    { taskType: "imageeditingqa", label: "Image Editing QA", icon: faImages },
    { taskType: "finalqa", label: "Final QA", icon: faEye },
    { taskType: "brandverifiedqa", label: "Brand Verified QA", icon: faClipboardCheck },
];

export const showRedo = (taskType) => {
    const shortTaskType = taskType.split(".")[0];
    switch (shortTaskType) {
        case "coding":
        case "imageediting":
            return false;
        default:
            return true;
    }
};

export const shouldShowImageApprovalNote = (taskType) => {
    switch (taskType) {
        case "imageediting":
        case "imageeditingqa":
        case "photography":
            return true;
        default:
            return false;
    }
};

export const checkRedoEligible = (taskType, incompleteTasks) => {
    switch (taskType) {
        case "scheduling":
        case "measuring":
            if (!incompleteTasks.includes(taskType)) {
                return true;
            }

            break;
        case "photography":
        case "imageediting":
        case "imageeditingqa":
            if (
                !incompleteTasks.includes("photography") &&
                !incompleteTasks.includes("imageediting") &&
                !incompleteTasks.includes("imageeditingqa")
            ) {
                return true;
            }

            break;
        case "coding":
        case "codingqa":
            if (!incompleteTasks.includes("coding") && !incompleteTasks.includes("codingqa")) {
                return true;
            }

            break;
        default:
            return false;
    }
};

export const getTaskLink = (task) => {
    const taskType = task.taskType.split(".")[0];
    const taskId = SECTION_MAP[taskType] ? SECTION_MAP[taskType].path : null;
    switch (taskType) {
        case "measuring":
            return `/shipment-editor/${task.context.shipmentKey}#measurements`;
        case "finalqa":
            return `${taskId}${task.key}/${task.context["key"]}`;
        case "photography":
        case "imageediting":
        case "imageeditingqa":
            return `${taskId}${task.key}/${task.context["photographyWipKey"]}`;
        case "coding":
        case "codingqa":
            return `${taskId}${task.key}/${task.context["codingWipKey"]}`;
        case "scheduling":
            return task.context && task.context.shipmentKey ? `${taskId}${task.context.shipmentKey}` : "";
        case "brandverifiedqa":
            return `${taskId}${task.key}/${task.context["key"]}`;
        default:
            return "";
    }
};

export const getAppendedTaskLabel = (taskType) => {
    const taskSubSection = taskType.split(".")[1] || "";
    switch (taskSubSection) {
        case "standard":
        case "default":
            return "";
        default:
            return capitalizeFirstLetter(taskSubSection);
    }
};

export const getLabelFQA = (total, index) => {
    return index === total - 1 ? "Original Post" : index === 0 ? "Most Recent Post" : `Repost ${total - index - 1}`;
};
